module.exports = __webpack_public_path__ + "img/9ac05eac18b4a1d792ddcc45e258f0b6.png";